import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { IntlProvider } from 'react-intl'
import { ThemeProvider, CssBaseline } from '@mui/material'
import theme from '../theme'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/700.css'

const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.jsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <IntlProvider locale="de-DE" defaultLocale="de-DE">
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App {...props} />
        </ThemeProvider>
      </IntlProvider>
    )
  },
})
